<template>
  <v-row>
    <v-col>
      <div v-if="shop">
        <span class="caption">
          {{ $t('bounties.redeemableAtShopCaption') }}
        </span>
        <v-icon>{{ icons.mdiMapMarker }}</v-icon>
        <span>{{ shop.name }} </span>
        <span v-if="shop.address">{{ shop.address }}</span>
      </div>
      <in-shop-requirements v-bind="{bounty, shop}" />
      <redeem-bounty-button
        v-if="enableRedeem && bounty.is_redeemable"
        :bounty="bounty"
      />
      <activate-bounty-button
        v-else-if="bounty.is_activateable"
        :bounty="bounty"
      />
      <bounty-disclaimer v-else />
      <div
        v-if="showPromoCodeListButton"
        class="mb-5 mt-3"
      >
        <v-btn
          text
          color="primary"
          @click="openPromoCodeListScreen"
        >
          {{$t('bounties.promotionCodeText')}}
        </v-btn>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import _ from 'lodash'
import {mapGetters} from 'vuex'
import {mdiCartPlus, mdiMapMarker, mdiCheck} from '@mdi/js'
import {getFormattedAddress} from '../../utils/getFormattedAddress'
import InShopRequirements from './Requirements/InShopRequirements'
import BountyDisclaimer from './BountyDisclaimer'
import RedeemBountyButton from './RedeemBountyButton'
import ActivateBountyButton from './ActivateBountyButton'

export default {
  name: 'InShopDetails',
  props: {
    bounty: {
      type: Object,
      required: true
    }
  },
  components: {
    InShopRequirements,
    BountyDisclaimer,
    RedeemBountyButton,
    ActivateBountyButton
  },
  data() {
    return {
      icons: {mdiCartPlus, mdiMapMarker, mdiCheck},
    }
  },
  computed: {
    ...mapGetters(['appSettings', 'extensionSettings']),
    disableRedeemRewardsWebapp() {
      return _.get(
        this.extensionSettings,
        'loyalty.disable_redeem_rewards_webapp',
        false
      )
    },
    disableRedeemRewardsWebappWhitelist() {
      return _.get(
        this.extensionSettings,
        'loyalty.disable_redeem_rewards_webapp_whitelist',
        []
      )
    },
    isRedeemTypeAllowed() {
      const promoRedeemTypes = _.get(
        this.bounty, 'promo_redeem_types', []
      )

      if (!_.isEmpty(promoRedeemTypes)) {
        return _.some(promoRedeemTypes, (redeemType) => {
          return _.includes(
            this.disableRedeemRewardsWebappWhitelist,
            redeemType.type
          )
        })
      }

      return false
    },
    promotionRedeemType() {
      return _.get(this.bounty, 'type')
    },
    enableRedeem() {
      if (
        this.disableRedeemRewardsWebapp &&
        !this.isRedeemTypeAllowed
      ) {
        return false
      }

      return true
    },
    showPromoCodeListButton() {
      return this.appSettings.show_promo_codes &&
        this.promotionRedeemType === 3 &&
        this.enableRedeem
    },
    shop() {
      if (!_.isEmpty(_.get(this.bounty, 'shop'))) {
        return {
          name: _.get(this.bounty, 'shop.name', ''),
          address: getFormattedAddress(
            _.get(this.bounty, 'shop.address')
          )
        }
      }
      return null
    }
  },
  methods: {
    openPromoCodeListScreen() {
      this.$router.push({name: 'promo-codes'})
    },
  }
}
</script>
